/** Pages the Sync Widget appears on (it owns no route of its own). */
export function isSyncWidgetRoute(pathname: string | null): boolean {
  // usePathname() is null only outside an app-router context (tests, edge
  // rendering) — fail open there rather than hiding the widget.
  if (pathname === null) return true
  const path = pathname.split('?')[0].replace(/\/+$/, '')
  // Dashboard (`/dashboards`, every board; the old `/dashboard` only
  // redirects there) and the integrations hub (including its detail
  // subroutes, so the widget does not vanish when a user drills into an
  // integration mid-import). settings/integrations is matched exactly: it is
  // only a redirect shell, and its real subpage (oauth-callback) owns its own
  // progress UI.
  return /^\/o\/[^/]+\/b\/[^/]+\/(dashboards|integrations(\/.*)?|settings\/integrations)$/.test(
    path,
  )
}
